<template>
    <div class="f-topic" v-if="hasTopicData">
        <!-- 帖子标题头部 -->
        <topic-header
            @toBoard="toBoard"
            @del="openConfirmToast">
        </topic-header>

        <!-- 帖子悬浮标题头部 -->
        <sticky-header></sticky-header>

        <!-- 帖子内容 -->
        <div class="f-topic-content">
            <div class="f-topic-content-main">
                <!-- 帖子正文内容 -->
                <main-content></main-content>
                <!-- 官方处理流程板块（问答板块下仅技术支持、rd审核员、问题管理员、管理员可见） -->
                <official-process-board ref="officialBoard"
                    v-if="hasShowOfficialBoard">
                </official-process-board>
                <!-- 回复区域 -->
                <topic-reply id="topic-reply"
                    @openConfirmToast="openConfirmToast">
                </topic-reply>
            </div>
        </div>

        <!-- 普通确认弹窗 -->
        <ui-confirm-box :is-open="confirm"
            :title="confirmTitle"
            :tip="confirmTips"
            :btn-tip="confirmBtn"
            @operate="operate">
        </ui-confirm-box>
    </div>
    <!-- 不展示 errImg -->
    <!-- <div v-else>
        <img :src="errorImg" class="request-error">
    </div> -->
</template>

<style lang="less">
    @import '../../assets/less/views/topic-content/topic-content.less';
</style>

<script>
import MainContent from './components/MainContent.vue';
import OfficialProcessBoard from './components/official-process';

import TopicHeader from './components/TopicHeader.vue';
import TopicReply from './components/TopicReply.vue';
import StickyHeader from './components/StickyHeader.vue';
import ConfirmBox from '@/components/confirm-box/box';

import {debounce, throttle} from '@/utils/debounceThrottle';
import {scrollToId, getScrollTop, getWindowHeight, getOffsetTop} from '@/utils/decorate/scroll';
import {openNewWindow, addEvent} from '@/utils/decorate/event';
import {mapGetters, mapState, mapActions, mapMutations} from 'vuex';
import toast from '@/utils/decorate/toast';

export default {
    beforeRouteEnter(to, from, next) {
        next(vm => vm.prevRoute = from);
    },
    components: {
        'main-content': MainContent,
        'official-process-board': OfficialProcessBoard,
        'topic-header': TopicHeader,
        'topic-reply': TopicReply,
        'sticky-header': StickyHeader,
        'ui-confirm-box': ConfirmBox
    },
    data() {
        return {
            confirm: false,
            errorImg: this.$store.state.home.errorImg,
            isShowTop: false,
            confirmTips: '',
            confirmTitle: '',
            confirmBtn: '',
            confirmType: '',
            replyId: '',
            prevRoute: null
        };
    },
    mounted() {
        let topicId = this.$route.params.topicid;
        let pageNo = this.$route.query.pageNo ? this.$route.query.pageNo : 1;
        this.$store.dispatch('getWholeTopicContent', {id: topicId, pageNo});
    },
    destroyed() {
        this.destroy();
    },
    computed: {
        ...mapGetters([
            'hasStickyReply',
            'hasShowOfficialBoard'
        ]),
        ...mapState({
            topicData: state => state.topicContent.topicData,
            replyData: state => state.topicContent.replyData,
            isReplyShow: state => state.topicContent.isReplyShow
        }),
        hasTopicData() {
            return Object.keys(this.topicData).length;
        }
    },
    methods: {
        ...mapMutations(['toggleReplyShow']),
        ...mapActions(['makeReplyAccepted', 'makeReplyRecommended']),
        scrollToId,
        watchHandler(to, from) {
            // 统计pv

            let params = Object.assign({}, to.params);
            let query = Object.assign({}, to.query);
            query.topicId = +params.topicid;
            this.$store.dispatch('getReplyContent', {query})
                .then(() => {
                    if (to.query.pageNo && to.query.pageNo !== from.query.pageNo) {
                        scrollToId('replyTop');
                    }
                });
        },
        toBoard() {
            let boardId = this.topicData.boardInfo.id;
            if (boardId < 3) {
                this.$router.push({name: 'homeTab', params: {moduleid: boardId}});
            }
            else {
                this.$router.push('/topic/list2/' + this.topicData.boardInfo.id);
            }
        },
        openConfirmToast({type, replyId}) {
            this.confirm = true;
            this.confirmType = type;
            switch (type) {
                case 'login': this.confirmTips = '您还没有登录，确认要登录吗?';
                    break;
                case 'delReply': this.confirmTitle = '确认删除回复';
                    this.confirmTips = '回复删除后将不可恢复';
                    this.confirmBtn = '删除';
                    this.replyId = replyId;
                    break;
                case 'delete': this.confirmTitle = '确认删除帖子';
                    this.confirmTips = '删除后帖子内容及回复将一并被删除，且不可恢复';
                    this.confirmBtn = '删除';
                    break;
            }
        },
        ok: debounce(function () {
            switch (this.confirmType) {
                case 'login': this.$store.dispatch('navToExit');
                    break;
                case 'delReply': this.delReply();
                    break;
                case 'delete': this.delTopic('delete');
                    break;
            }
        }),
        delTopic(type) {
            let topicId = this.topicData.topicInfo.topicId;
            let enable = 1;
            this.$store.dispatch('managerOperation', {type, topicId, enable})
                .then(() => {
                    this.toBoard();
                });
        },
        delReply() {
            let replyId = this.replyId;
            let topicId = this.topicData.topicInfo.topicId;
            this.$store.dispatch('managerOperation', {type: 'delReply', replyId})
                .then(() => {
                    let topicId = this.topicData.topicInfo.topicId;
                    this.$store.dispatch('getReplyContent', {query: {topicId}});
                })
                .then(() => {
                    this.$store.dispatch('getTopicContent', {id: topicId});
                    this.$store.commit('updateReplyDeleteState', {replyId, hasTopReply: this.hasStickyReply});
                });
        },
        changeConfirm(val) {
            this.confirm = val;
        },
        destroy() {
            this.$store.commit('clearTopicContentData');
        },
        operate(type) {
            if (type === 'ok') {
                this.ok();
            }
            this.changeConfirm(false);
        }
    }
};
</script>
